import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LANGUAGES, useApp } from "@/state/AppContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function TranslationPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { currentResult, language } = useApp();
  const defaultTab = params.get("tab") === "full" ? "full" : "simple";

  if (!currentResult) {
    return <div className="p-6" data-testid="tr-empty">Keine Übersetzung verfügbar.</div>;
  }

  const langLabel = LANGUAGES.find(l => l.code === language)?.label || language;

  return (
    <div className="px-5 pt-4 pb-8" data-testid="translation-page">
      <button onClick={() => navigate(-1)} data-testid="tr-back" className="text-slate-600 flex items-center gap-1 text-sm mb-3">
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>
      <h1 className="text-2xl font-bold text-slate-900">In deiner Sprache erklärt</h1>
      <div className="mt-2 flex items-center gap-2 text-slate-600 text-sm">
        <span className="px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 font-medium">Deutsch</span>
        <span>→</span>
        <span className="px-2.5 py-1 rounded-full bg-blue-600 text-white font-medium">{langLabel}</span>
      </div>

      <Tabs defaultValue={defaultTab} className="mt-6">
        <TabsList className="grid grid-cols-2 w-full bg-blue-50 rounded-2xl h-12 p-1">
          <TabsTrigger value="simple" data-testid="tab-simple" className="rounded-xl">Einfach erklärt</TabsTrigger>
          <TabsTrigger value="full" data-testid="tab-full" className="rounded-xl">Original übersetzt</TabsTrigger>
        </TabsList>
        <TabsContent value="simple" className="mt-4">
          <div className="rounded-3xl bg-white border border-slate-200 p-4 whitespace-pre-wrap leading-relaxed text-slate-800" data-testid="tr-simple">
            {currentResult.translation_simple || currentResult.plain_explanation || "—"}
          </div>
        </TabsContent>
        <TabsContent value="full" className="mt-4">
          <div className="rounded-3xl bg-white border border-slate-200 p-4 whitespace-pre-wrap leading-relaxed text-slate-800" data-testid="tr-full">
            {currentResult.translation_full || currentResult.original_text || "—"}
          </div>
          <p className="mt-3 text-xs text-slate-500">
            Bei rechtlich relevanten Dokumenten bleibt das deutsche Original maßgeblich.
          </p>
        </TabsContent>
      </Tabs>
    </div>
  );
}
